exports.withOrientation = ({ mediaQuery, orientation }) =>
  `${mediaQuery} and (orientation: ${orientation})`;
